import { adjustedCategory, categoryLabel, PRODUCT_CATEGORIES } from "../config/productCategories";

interface CategorizedLead { category?: string; adjustedCategory?: string }
const manualPrefix = "lead-category:";

// Keep imported collections separate from product classifications, even when
// an admin names a collection "tools" or another master category ID.
export const leadCategoryKey = (name: string): string => manualPrefix + name;
export const leadCategoryIdentity = (key: string): string =>
  key.startsWith(manualPrefix) ? key.slice(manualPrefix.length) : key;
export const leadCategoryLabel = (
  key: string,
  customLabels: Readonly<Record<string, string>> = {}
): string => customLabels[key]?.trim() || (
  key.startsWith(manualPrefix) ? leadCategoryIdentity(key) : categoryLabel(key)
);

export const getLeadCategories = (
  manualCategories: readonly string[] = [],
  hiddenCategories: readonly string[] = []
): string[] => [
  ...[...new Set(manualCategories)].filter(Boolean).map(leadCategoryKey),
  ...PRODUCT_CATEGORIES
    .filter(category => !hiddenCategories.includes(category.id))
    .map(category => category.id),
];

export const matchesLeadCategory = (lead: CategorizedLead, selected: string): boolean =>
  selected === "all" || (selected.startsWith(manualPrefix)
    ? lead.category === selected.slice(manualPrefix.length)
    : adjustedCategory(lead) === selected);

export const getLeadCategoryCounts = (leads: readonly CategorizedLead[] = []): Map<string, number> => {
  const counts = new Map<string, number>();
  if (leads.length) counts.set("all", leads.length);
  for (const lead of leads) {
    const master = adjustedCategory(lead);
    if (master) counts.set(master, (counts.get(master) ?? 0) + 1);
    if (lead.category) {
      const manual = leadCategoryKey(lead.category);
      counts.set(manual, (counts.get(manual) ?? 0) + 1);
    }
  }
  return counts;
};
